import { combineReducers } from 'redux';
import themeUsersReducer from './themeUsers/reducers';
import { readMessageReducer } from './message/reducers';
import { readNotificationReducer } from './notification/reducers';
import authReducer from './authentication/reducers';
import ChangeLayoutMode from './themeLayout/reducers';
import { teamReducer } from './team/reducers';
import { userReducer } from './users/reducers';
import { sellersReducer } from './sellers/reducers';
import { headerSearchReducer } from './headerSearch/reducers';
import orderReducer from './orders/reducers';
import galleryReducer from './gallary/reducers';
import chartContentReducer from './chartContent/reducers';
import { emailReducer, SingleEmailReducer } from './email/reducers';
import { productReducer, SingleProductReducer } from './product/reducers';
import { chatReducer, SingleChatReducer, groupChatReducer, SingleChatGroupReducer } from './chat/reducers';
import { projectReducer, SingleProjectReducer } from './project/reducers';
import cartData from './cart/reducers';
import Todo from './todo/reducers';
import Note from './note/reducers';
import Contact from './contact/reducers';
import Profile from './profile/reducers';
import Calender from './calendar/reducers'; 
/* custom */
import paymentReducer from './payment/reducers';
import addressReducer from './address/reducers';
import shipmentRateReducer from './shipmentRate/reducers';
import shipmentReducer from './shipment/reducers';
import pickupReducer from './pickup/reducers';
import creditReducer from './credit/reducers';
import kbankReducer from './kbank/reducers';
import billReducer from './bill/reducers';

const rootReducers = combineReducers({  
  themeUsers: themeUsersReducer,
  headerSearchData: headerSearchReducer,
  message: readMessageReducer,
  notification: readNotificationReducer,
  orders: orderReducer,
  sellers: sellersReducer,
  users: userReducer,
  team: teamReducer,
  auth: authReducer,
  gallery: galleryReducer,
  email: emailReducer,
  emailSingle: SingleEmailReducer,
  products: productReducer,
  product: SingleProductReducer,
  chatSingle: SingleChatReducer,
  chatSingleGroup: SingleChatGroupReducer,
  chat: chatReducer,
  groupChat: groupChatReducer,
  projects: projectReducer,
  project: SingleProjectReducer,
  ChangeLayoutMode,
  chartContent: chartContentReducer, 
  cart: cartData,
  Todo,
  Note,
  Contact,
  Profile,
  Calender,
  /*custom*/
  payments: paymentReducer,
  address: addressReducer,
  shipmentRates: shipmentRateReducer,
  shipment: shipmentReducer,
  pickup: pickupReducer,
  credit: creditReducer,
  kbank: kbankReducer,
  bill: billReducer,
});

export default rootReducers;
